"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _Notification["default"];
  }
});
var _Notification = _interopRequireDefault(require("./Notification"));